import { Lacre } from '@tivic-team/manager-ts/dist/mob/entities/lacre/Lacre.entity';

export class LacreDTO extends Lacre{
    constructor() {
        super();
    }

}

export class LacreDTOList {
    items: Array<LacreDTO>;
    total: number;

    constructor() {}
}